export class Controller {
  constructor() {
    this.thisHTML = document.querySelector('html');
    this.form = document.querySelector('#toggle-gray-scale');
    
    if (!this.form) {
      return;
    }

    this.trigger = this.form.querySelector('#enable-gray-scale');
    this.triggerInput = this.form.querySelector('.input-toggle-checkbox');
    this.triggerSwitch = this.form.querySelector('.input-toggle-switch');
  }

  enable() {
    this.thisHTML.setAttribute('data-gray-scale', 'enabled');
    this.triggerInput.classList.add('is-checked');
    localStorage.setItem('gray-scale', 'enabled');
  }

  disable() {
    this.triggerInput && this.triggerInput.classList.remove('is-checked');
    this.thisHTML.setAttribute('data-gray-scale', 'disabled');
    localStorage.removeItem('gray-scale');
  }

  isEnabled() {
    return this.thisHTML.getAttribute('data-gray-scale') === 'enabled';
  }

  setLocalStorage() {
    const thisHTML = document.querySelector('html');
    localStorage.setItem('gray-scale', thisHTML.getAttribute('data-gray-scale'));
  }

}